document.addEventListener("DOMContentLoaded", function () {
  const openButtons = document.querySelectorAll("[data-open-modal]");
  const closeButtons = document.querySelectorAll("[data-close-modal]");
  const modalWrapper = document.querySelector(".modal-wrapper");
  const modalVideo = document.getElementById("modal-video");
  const stickyHeader = document.querySelector(".mega-sticky-header");
  const anchorId = "backpack-video";
  let anchorScrollActive = false;
  let anchorScrollObserver;
  let anchorScrollTimeout;
  let userInteractedSinceAnchor = false;

  function getAnchorHeaderOffset() {
    if (!stickyHeader || stickyHeader.classList.contains("hide")) return 0;

    const headerRect = stickyHeader.getBoundingClientRect();
    return headerRect.bottom > 0 ? headerRect.height : 0;
  }

  function scrollToVideoAnchor() {
    if (!anchorScrollActive || userInteractedSinceAnchor) return;

    const target = document.getElementById(anchorId);
    if (!target) return;

    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const correctedTop = Math.max(0, targetTop - getAnchorHeaderOffset());

    // Avoid a visible jump when the anchor is already close enough.
    if (Math.abs(window.scrollY - correctedTop) < 8) return;

    window.scrollTo({
      top: correctedTop,
      behavior: "auto"
    });
  }

  function scheduleAnchorScroll(delay = 700) {
    if (!anchorScrollActive || userInteractedSinceAnchor) return;

    window.clearTimeout(anchorScrollTimeout);
    anchorScrollTimeout = window.setTimeout(() => {
      anchorScrollTimeout = undefined;
      scrollToVideoAnchor();
    }, delay);
  }

  function stopAnchorSettling() {
    anchorScrollActive = false;
    window.clearTimeout(anchorScrollTimeout);
    anchorScrollTimeout = undefined;
    if (anchorScrollObserver) {
      anchorScrollObserver.disconnect();
      anchorScrollObserver = undefined;
    }
  }

  function settleVideoAnchor() {
    if (window.location.hash !== `#${anchorId}`) return;

    stopAnchorSettling();
    anchorScrollActive = true;
    userInteractedSinceAnchor = false;

    // Let the initial anchor jump and layout-shifting content settle first.
    scheduleAnchorScroll(1000);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scheduleAnchorScroll(500));
    }

    const mainContent = document.getElementById("MainContent");
    if (mainContent && "ResizeObserver" in window) {
      anchorScrollObserver = new ResizeObserver(() => scheduleAnchorScroll(500));
      anchorScrollObserver.observe(mainContent);
    }

    window.setTimeout(stopAnchorSettling, 4000);
  }

  ["wheel", "touchstart", "pointerdown", "keydown"].forEach((eventName) => {
    window.addEventListener(eventName, () => {
      if (anchorScrollActive) {
        userInteractedSinceAnchor = true;
        stopAnchorSettling();
      }
    }, { passive: true });
  });

  window.addEventListener("load", () => scheduleAnchorScroll(500), { once: true });
  window.addEventListener("hashchange", settleVideoAnchor);
  settleVideoAnchor();

  // Open modal + play video
  openButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      modalWrapper.classList.remove("is-hidden");
      modalWrapper.classList.add("is-active");
      modalWrapper.setAttribute("aria-hidden", "false");
      document.body.classList.add("overflow-hidden");

      // hide sticky header
      if (stickyHeader) stickyHeader.style.display = "none";

      // reset + play video
      modalVideo.currentTime = 0;
      modalVideo.play();
    });
  });

  // Close modal
  function closeModal() {
    modalVideo.pause();
    modalWrapper.classList.remove("is-active");
    modalWrapper.classList.add("is-hidden");
    modalWrapper.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");

    // show sticky header again
    if (stickyHeader) stickyHeader.style.display = "";
  }

  closeButtons.forEach((btn) => {
    btn.addEventListener("click", closeModal);
  });

  modalWrapper.addEventListener("click", function (e) {
    if (e.target.dataset.closeModal !== undefined) {
      closeModal();
    }
  });

  document.addEventListener("keyup", function (e) {
    if (e.key === "Escape") {
      closeModal();
    }
  });
});
